import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Container } from "react-bootstrap";
import Markdown from 'react-markdown';
import i18n from "../../I18n";
import LoadMoreSpinner from "component/common/LoadMoreSpinner";
import { createAction, getTranslationField } from "utils";
import "./LevelRuleMobile.scss";


const SplitLine = () => (
  <div className="split-line" />
)

const SingleLevelRule = ({
  isLastOne,
  title,
  content,
}) => (
  <>
    <div className="level-rule-item-section">
      <div className="level-rule-second-title subheading">
        {title}
      </div>
      <div className="level-rule-detail-message body-1">
        <Markdown>{content}</Markdown>
      </div>
    </div>
    {
      isLastOne
        ? null
        : <SplitLine />
    }
  </>
)

const LevelRuleMobile = ({
  language,
  levelRules,
  levelRulesLoading,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(createAction("levels/fetchLevelRules")());
  }, []);

  return (
    <Container className="level-rule-mobile-page-container">
      <div className="level-rule-mobile-page">
        <div className="level-rule-title title-small">{i18n.t("levelRules")}</div>
        {
          levelRulesLoading
            ? <div className="level-rule-mobile-loading">
              <LoadMoreSpinner />
            </div>
            : <div>
              {
                levelRules?.map((rule, index) => (
                  <SingleLevelRule
                    key={rule.id}
                    isLastOne={(index + 1) === levelRules.length}
                    title={getTranslationField(rule, "title", language)}
                    content={getTranslationField(rule, "content", language)}
                  />
                ))
              }
            </div>
        }
      </div>
    </Container>

  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  levelRules: state.levels.levelRules,
  levelRulesLoading: state.levels.levelRulesLoading,
})

export default connect(mapStateToProps)(LevelRuleMobile);
